import React from "react";
import { useAuth } from "../lib/useAuth";

function waitForPi(timeoutMs = 8000, intervalMs = 100) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    (function check(){
      if (typeof window !== "undefined" && window.Pi && typeof window.Pi.authenticate === "function")
        return resolve(window.Pi);
      if (Date.now() - start > timeoutMs) return reject(new Error("Pi SDK not ready"));
      setTimeout(check, intervalMs);
    })();
  });
}

const pill = {
  display:"inline-flex",
  alignItems:"center",
  justifyContent:"center",
  padding:"14px 22px",
  borderRadius:28,
  border:"1px solid #2b2663",
  background:"#2f2a6e",
  color:"#fff",
  fontWeight:700,
  fontSize:16,
  letterSpacing:.2,
  cursor: "pointer",
  transition: "opacity 0.2s ease",
};

const pillDisabled = {
  ...pill,
  opacity: 0.6,
  cursor: "not-allowed",
};

export default function PiSignInButton({ label = "Sign in with Pi" }) {
  const { signIn } = useAuth();
  const [busy, setBusy] = React.useState(false);
  const [ready, setReady] = React.useState(false);

  React.useEffect(() => {
    let dead = false;
    waitForPi()
      .then(() => !dead && setReady(true))
      .catch((err) => {
        if (!dead) {
          console.warn("[PiSignInButton] Pi SDK not available:", err?.message);
          setReady(false);
        }
      });
    return () => { dead = true; };
  }, []);

  async function handle() {
    try {
      setBusy(true);
      const Pi = await waitForPi();
      
      // Request username + payments scopes for full Pi integration
      const auth = await Pi.authenticate(
        ["username", "payments"],
        (payment) => console.log("[Pi SDK] Incomplete payment found:", payment)
      );
      
      console.log("[PiSignInButton] Authentication successful, calling signIn()");
      
      // Call the context signIn which will store token + user
      await signIn(auth);
      
    } catch (e) {
      console.error("[PiSignInButton] Sign in failed:", e);
      alert(e?.message || "Sign in failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      style={!ready || busy ? pillDisabled : pill}
      onClick={handle}
      disabled={!ready || busy}
      aria-label={label}
    >
      {busy ? "Signing in…" : label}
    </button>
  );
}